<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>新建散客消费单</el-breadcrumb-item>
    </el-breadcrumb>

    <div >
      <div style="text-align: center">
        <span >消费人次：</span>
        <el-input v-model="skOrder.peoples" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" style="width: 30%;"></el-input>
      </div>
      <el-card class="box-card">
        <div style="text-align: right">
          <el-button size="mini" plain @click="showSkConsumptionDialog">添加服务明细</el-button>
        </div>
        <el-table :data="skSelectConsumptionList" fit border stripe="stripe" width="100%"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="userName"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteSkOrderSelectConsumptionList(scope.$index, skSelectConsumptionList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="数量" width="180"
          >
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.num"
                               size="mini" :precision="0"
                               @change="changeSkOrderZj" :min="1" :max="1000" ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" >
          </el-table-column>
          <el-table-column
            align="center"
            label="金额小计">
            <template slot-scope="scope">
              <div v-if="scope.row.isShowDia === 1">
                {{ (scope.row.price * scope.row.num * scope.row.dia).toFixed(2)}}
              </div>
              <div v-if="scope.row.isShowDia !== 1">
                <div v-if="scope.row.type === 1">
                  {{(scope.row.price * scope.row.num).toFixed(2)}}
                </div>
                <div v-if="scope.row.type === 2">
                  {{ (scope.row.price * scope.row.num).toFixed(2)}}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top:10px;text-align: right">
          <el-button size="mini" plain @click="showServerDialog">添加服务人员</el-button>
        </div>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >应收金额：</span>
            <el-input v-model="skOrder.receivable" readonly  placeholder="请输入内容"  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="skOrder.moLing"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      :disabled="isSkMoLingSet"  @change="setSkOrderMoLing"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="skOrder.couZheng"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      :disabled="isSkCouZhengSet"
                      @change="setSkOrderCouZheng"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 实收金额：</span>
            <el-input v-model="skOrder.received" readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
        </div>

        <div  style="width:100%;margin-top: 10px">
          <div style="width:75px;">支付方式：</div>
          <div  v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      :readonly="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
                    || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                      || item.payEnName == 'kuaishoutuangou'  || item.payEnName == 'gaodetuangou'"
                      @change="resetSkOrderPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <span style="width: 10%;margin-left: 5px;"> 备注说明：</span>
        <el-input v-model="skOrder.comment" type="textarea" placeholder="请输入内容" size="mini" />
      </el-card>
    </div>

    <span class="dialog-footer">
        <el-button size="mini" @click="closeSkOrderDialog">取 消</el-button>
        <el-button size="mini" @click="createSkOrder" :disabled="orderIsSubmit == 1">确 定</el-button>
    </span>

    <!-- 显示服务和产品-->
    <el-drawer
      title="添加散客消费项目"
      size="60%"
      :visible.sync="skConsumptionDrawer"
      :before-close="closeSkConsumptionDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <el-card>
              <el-tree
                :data="skConsumptionTypeList"
                :props="consumptionTypeProps"
                @node-click="skOrderconsumptionTypeClick"
                :highlight-current="true"
                node-key="id"
                :filter-node-method="consumptionTypeFilterNode"
                default-expand-all
                ref="serviceTree"
              >
              </el-tree>
            </el-card>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-card class="box-card">
            <el-table height="580px"
                      :data="skConsumptionList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                label="操作" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.type === 1">
                    <el-input-number v-model="scope.row.num"
                                     size="mini" :precision="0"
                                     :disabled="scope.row.isPackage === 2"
                                     @change="skOrderNumHandleChange(scope.row)" :min="0" :max="1000" label="描述文字"></el-input-number>
                  </div>
                  <div v-if="scope.row.type === 2">
                    <el-input-number v-model="scope.row.num"
                                     size="mini" :precision="0"
                                     @change="skOrderNumHandleChange(scope.row)" :min="0" :max="1000" label="描述文字"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="consumptionName"
                label="服务名称" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="price"
                label="标准价格" >
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </el-drawer>

    <!-- 选择服务人员 -->
    <el-dialog
      title="服务人员列表"
      size="400px"
      :visible.sync="serverDialogVisible"
      :before-close="closeServerDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="serverList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                @selection-change="serverSelectChange">
        <el-table-column
          align="center"
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="userName"
          label="服务人员姓名">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      areaId: window.sessionStorage.getItem('areaId'),
      currentOrgId: window.sessionStorage.getItem('currentOrgId'),
      userId: window.sessionStorage.getItem("userId"),
      authorities: window.sessionStorage.getItem('authorities'),
      orgLevel: window.sessionStorage.getItem('orgLevel'),
      moLingRate: window.sessionStorage.getItem('moLingRate'),
      orgName: window.sessionStorage.getItem('orgName'),
      orderIsSubmit: 2,            //是否提交，1是 2否，默认为未提交
      skOrderDialogVisible:false,  //散客订单窗口是否显示
      skConsumptionDrawer:false,   //散客项目窗口是否显示
      skSelectConsumptionList:[],  //已选消费项目
      skConsumptionTypeList:[],    //消费项目类别
      skConsumptionList:[],        //消费项目列表
      skOrder:{
        orderOrgId:'',   //订单所属机构id
        orderOrgName:'', //订单所属机构名称
        receivable:'',   //应收金额
        received:'',     //实收金额
        consumptions:[], //消费项目
        cashPay:'',      //现金支付
        weChatPay:'',    //微信支付
        aliPay:'',       //支付宝支付
        bankPay:'',      //银行卡支付
        lakalaPay:'',    //拉卡拉支付
        posPay:'',       //pos机支付
        miniWeChatPay:'',//微信小程序支付
        scanCodePay:'',  //扫码支付
        moLing:'',       //抹零金额
        couZheng:'',     //凑整金额
        servers:[],      //服务人员
        orderPayTypeList:[],//订单支付方式
        isLocal:2,       //是否本地消费
        creator:'',      //创建人
        modifier:'',      //更新人
        comment:'',
        peoples:'',
        reserveId:0,
      },
      selectServerList:[],
      isSkMoLingSet:false,
      isSkCouZhengSet:false,
      orgPayTypeList:[],
      orderPayTypeTotalMoney:[],
      consumptionTypeProps:{       //消费项目树展示信息
        label: 'consumptionTypeName',
        children: 'children'
      },
      dataType:'',
      consumptionTypeId:'',
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        consumptionId:''
      },
      serverList:[],
      serverDialogVisible:false,
      kuaishoutuangou:0,
      douyintuangou:0,
      meituantuangou:0,
      koubeituangou:0,
      gaodetuangou:0,
      xiaochengxutuangou:0
    }
  },
  methods:{
    async showSkConsumptionDialog(){
      this.skConsumptionDrawer = true;
      this.skConsumptionList = [];
      const {data:res} = await this.$http.get(`/consumptionType/orgId/${this.currentOrgId}`)
      this.skConsumptionTypeList = res.data;
    },
    closeSkConsumptionDialog(){
      this.jsSkOrderAmount();
      this.skConsumptionDrawer = false;
    },
    deleteSkOrderSelectConsumptionList(index,rows){
      rows.splice(index, 1);
      this.skOrder.moLing = 0;
      this.skOrder.couZheng = 0;
      this.isSkMoLingSet=false;
      this.isSkCouZhengSet = false;
      //消费项目发生了变化，重新计算订单金额
      this.jsSkOrderAmount();
    },
    jsSkOrderAmount(){
      this.skOrderAmount();
      this.setSkOrderPay();
    },
    skOrderAmount(){
      let receivable = 0; //应收金额
      this.kuaishoutuangou=0;
      this.douyintuangou=0;
      this.meituantuangou=0;
      this.koubeituangou=0;
      this.xiaochengxutuangou=0;
      this.gaodetuangou=0;
      let result = true;
      this.skSelectConsumptionList.map((item) =>{
        if (item.consumptionTypeName !== '抖音团购' && item.consumptionTypeName !== '美团团购'
          && item.consumptionTypeName !== '口碑团购' && item.consumptionTypeName !== '小程序团购'
          && item.consumptionTypeName !== '活动修脚' && item.consumptionTypeName !== '快手团购'
          && item.consumptionTypeName !== '高德团购'){
          result = false;
        }
        if (item.consumptionTypeName === '快手团购'){
          this.kuaishoutuangou += item.price * item.num
        }
        if (item.consumptionTypeName === '抖音团购'){
          this.douyintuangou += item.price * item.num
        }
        if (item.consumptionTypeName === '美团团购'){
          this.meituantuangou += item.price * item.num
        }
        if (item.consumptionTypeName === '口碑团购'){
          this.koubeituangou += item.price * item.num
        }
        if (item.consumptionTypeName === '小程序团购'){
          this.xiaochengxutuangou += item.price * item.num
        }
        if (item.consumptionTypeName === '高德团购'){
          this.gaodetuangou += item.price * item.num
        }
        receivable += item.price * item.num;
      })
      this.isSkMoLingSet = result;
      this.skOrder.receivable = receivable.toFixed(2);
      this.skOrder.received = receivable.toFixed(2);
    },
    changeSkOrderZj(){
      this.jsSkOrderAmount();
      this.skOrder.moLing=0;
      this.skOrder.couZheng=0;
      this.isSkMoLingSet=false;
      this.isSkCouZhengSet = false;
    },
    resetSkOrderPay(){
      let money = 0;
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.money > 0){
          if (item.money > (this.skOrder.received - money)){
            item.money = (this.skOrder.received - money).toFixed(2);
          }
          money += item.money - 0;
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((this.skOrder.received - money) < 0){
            item.money = 0;
          } else {
            item.money = (this.skOrder.received - money).toFixed(2);
          }
        }
      })
    },
    setSkOrderMoLing(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsSkOrderAmount();
      let maxMoLingMoney = (this.skOrder.receivable * this.moLingRate / 100).toFixed(2);
      let skMoLing = this.skOrder.moLing - 0;
      let skCouzheng = this.skOrder.couZheng - 0;
      if (skMoLing > (maxMoLingMoney - 0)){
        this.$message.warning("抹零金额不能超过应收金额的" + this.moLingRate + "%");
        this.skOrder.moLing = 0;
        return;
      }
      this.isSkCouZhengSet = true;
      this.skOrder.received = (this.skOrder.receivable - skMoLing  + skCouzheng).toFixed(2);
      this.setSkOrderPay();
    },
    setSkOrderCouZheng(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsSkOrderAmount();
      let skMoLing = this.skOrder.moLing - 0;
      let skCouzheng = this.skOrder.couZheng - 0;
      this.isSkMoLingSet = true;
      this.skOrder.received = (this.skOrder.receivable - skMoLing  + skCouzheng).toFixed(2);
      this.setSkOrderPay();
    },
    setSkOrderPay(){
      //先将设置过的全部情况
      this.orgPayTypeList.map((item) =>{
        item.money = '';
      })
      let needPay = (this.skOrder.received - this.kuaishoutuangou - this.meituantuangou - this.douyintuangou - this.koubeituangou - this.xiaochengxutuangou  - this.gaodetuangou).toFixed(2);
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin') {
          if (needPay < 0) {
            item.money = 0;
          } else {
            item.money = needPay;
          }
        }
        if (item.payEnName === 'kuaishoutuangou') {
          item.money = this.kuaishoutuangou.toFixed(2);
        }
        if (item.payEnName === 'meituantuangou') {
          item.money = this.meituantuangou.toFixed(2);
        }
        if (item.payEnName === 'douyintuangou') {
          item.money = this.douyintuangou.toFixed(2);
        }
        if (item.payEnName === 'koubeituangou') {
          item.money = this.koubeituangou.toFixed(2);
        }
        if (item.payEnName === 'xiaochengxutuangou') {
          item.money = this.xiaochengxutuangou.toFixed(2);
        }
        if (item.payEnName === 'gaodetuangou') {
          item.money = this.gaodetuangou.toFixed(2);
        }
      })
    },
    //创建散客订单
    async createSkOrder(){
      this.orderIsSubmit = 1;
      if (this.skOrder.peoples === ''){
        this.$message.warning("请添加消费人次！")
        return;
      }
      if ((this.skOrder.peoples - 0) < 1){
        this.$message.warning("消费人次不能小于1！")
        return;
      }
      if (this.skSelectConsumptionList.length === 0){
        this.$message.warning("请添加消费明细！")
        return;
      }
      if (this.selectServerList.length === 0){
        this.$message.warning("请添加服务人员！")
        return;
      }
      let totalMoney = 0;
      this.orgPayTypeList.map((item) => {
        totalMoney += item.money - 0;
      })
      if ((this.skOrder.received -0 ).toFixed(2) !== totalMoney.toFixed(2)){
        return this.$message.warning("支付金额与实收金额不一致，请仔细检查");
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.skOrder.orderOrgId = this.currentOrgId;
      this.skOrder.consumptions = this.skSelectConsumptionList;
      this.skOrder.orderPayTypeList = this.orgPayTypeList;
      this.skOrder.servers = this.selectServerList;
      this.skOrder.creator = this.userId;
      this.skOrder.reserveId = this.reserveId;
      const {data:res} = await this.$http.post(`/order/skOrder`,this.skOrder);
      if (res.code === 200){
        this.$message.success("操作成功！");
        this.orderIsSubmit = 2;
      } else {
        this.$message.error(res.msg)
        this.orderIsSubmit = 2;
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.$router.push('/orders')
    },
    async skOrderconsumptionTypeClick(data){
      this.dataType = data.type;
      if (data.consumptionTypeName === '服务分类'){
        this.dataType = 1;
      }
      if (data.consumptionTypeName === '产品分类'){
        this.dataType = 2;
      }
      this.consumptionTypeId = data.consumptionTypeId;
      await this.loadSkOrderConsumptionList();
    },
    async loadSkOrderConsumptionList(){
      this.consumptionRequest.dateType = this.dataType;
      this.consumptionRequest.typeId = this.consumptionTypeId
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = this.consumptionQueryText;
      this.consumptionRequest.pageNum = 1;
      this.consumptionRequest.pageSize = 1000;
      const {data:res} = await this.$http.post(`/load/list/consumption`, this.consumptionRequest)
      this.skConsumptionList = res.data;
    },
    skOrderNumHandleChange(value){
      let result = true;
      for (let i = 0; i < this.skSelectConsumptionList.length; i++) {
        if (this.skSelectConsumptionList[i].id === value.id && value.num > 0){
          this.skSelectConsumptionList[i].num = value.num;
          result = false;
        }
        if (this.skSelectConsumptionList[i].id === value.id && value.num === 0){
          this.skSelectConsumptionList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.skSelectConsumptionList.push(value);
      }
    },
    setSkUpdateOrderPay(){
      let kuaishoutuangou = 0;
      let douyintuangou = 0;
      let meituantuangou=0;
      let koubeituangou=0;
      let gaodetuangou=0;
      let xiaochengxutuangou=0;
      this.updateOrderDetailList.map((item) =>{
        if (item.consumptionTypeName === '快手团购'){
          kuaishoutuangou += item.received;
        }
        if (item.consumptionTypeName === '抖音团购'){
          douyintuangou += item.received;
        }
        if (item.consumptionTypeName === '美团团购'){
          meituantuangou += item.received;
        }
        if (item.consumptionTypeName === '口碑团购'){
          koubeituangou += item.received;
        }
        if (item.consumptionTypeName === '小程序团购'){
          xiaochengxutuangou += item.received;
        }
        if (item.consumptionTypeName === '高德团购'){
          gaodetuangou += item.received;
        }
      })
      let money = 0;
      let needPay = (this.updateOrderDetail.orderReceived -  kuaishoutuangou - meituantuangou - douyintuangou - koubeituangou - xiaochengxutuangou  - gaodetuangou).toFixed(2);
      this.orgPayTypeList.map((item) => {
        if (item.payEnName !== 'xianjin' && item.payEnName !== 'meituantuangou' && item.payEnName !== 'douyintuangou'
          && item.payEnName !== 'koubeituangou' && item.payEnName !== 'xiaochengxutuangou'
          && item.payEnName !== 'kuaishoutuangou'  && item.payEnName !== 'gaodetuangou'){
          money += item.money - 0;
        }
        if (item.payEnName === 'kuaishoutuangou') {
          item.money = kuaishoutuangou.toFixed(2);
        }
        if (item.payEnName === 'meituantuangou') {
          item.money = meituantuangou.toFixed(2);
        }
        if (item.payEnName === 'douyintuangou') {
          item.money = douyintuangou.toFixed(2);
        }
        if (item.payEnName === 'koubeituangou') {
          item.money = koubeituangou.toFixed(2);
        }
        if (item.payEnName === 'xiaochengxutuangou') {
          item.money = xiaochengxutuangou.toFixed(2);
        }
        if (item.payEnName === 'gaodetuangou') {
          item.money = gaodetuangou.toFixed(2);
        }
      })
      this.orgPayTypeList.map((item) => {
        if (item.payEnName === 'xianjin'){
          if ((needPay - money) < 0){
            item.money = 0;
          } else {
            item.money = (needPay - money).toFixed(2);
          }
        }
      })
    },
    showServerDialog(){
      this.loadServer();
      this.serverDialogVisible = true;
    },
    async loadServer(){
      const {data:res} = await this.$http.get(`/users/valida/${2}/orgId/${this.currentOrgId}/pageNum/1/pageSize/99`)
      this.serverList = res.data.list;
    },
    closeServerDialog(){
      this.resetHyOrderUserRate();
      this.serverDialogVisible = false;
    },
    deleteServerShowList(index,rows){
      rows.splice(index, 1);
      this.resetHyOrderUserRate();
    },
    setHyOrderUserRate(){
      let rateTotal = 0;
      this.selectServerList.map((item, index) =>{
        if (index === this.selectServerList.length-1){
          let rate = 100 - rateTotal;
          if (rate <= 0){
            item.rate = 0;
          } else {
            item.rate = rate.toFixed(2);
          }
        } else {
          rateTotal += item.rate - 0;
        }
      })
    },
    closeSkOrderDialog(){
      this.$router.go(-1)
    },
    consumptionTypeFilterNode(value, data) {
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    async loadOrgPayType(){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${this.currentOrgId}`)
      this.orgPayTypeList = res.data;
    },

    async loadOrderPayTypeTotalMoney(){
      const {data:res} = await this.$http.get(`/order/payTypeTotal/orgId/${this.currentOrgId}`)
      this.orderPayTypeTotalMoney = res.data;
    },
    serverSelectChange(val){
      this.selectServerList = val;
    },
    resetHyOrderUserRate(){
      let rateTotal = 0;
      if (this.selectServerList.length > 0){
        this.selectServerList.map((item, index) => {
          if (index === this.selectServerList.length -1){
            let rate = 100 - rateTotal;
            item.rate = rate.toFixed(2)
          } else {
            item.rate = (100 / this.selectServerList.length).toFixed(2);
            rateTotal += item.rate - 0;
          }
        })
      }
    },
  },
  created(){
    this.loadOrgPayType();
    this.loadOrderPayTypeTotalMoney();
  }
}
</script>

<style scoped lang="less">
.container {
  height: 1500px;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
//flex: 1;
  width: auto;
//border: 1px solid;
  margin: 10px 0;
//width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
.el-dialog__title{
  color: #333;
}
.el-dialog__close{
  color: #333 !important;
}
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewSkOrder.vue